import { Enterprise } from "interfaces";
import { post , get} from "services/config"


export const create = async <T>(payload: T, path = '/create-entreprise'): Promise<any> => {
    try {
      const response = await post<any>(path, (payload as any),{
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error: any) { 
      throw new Error(error.response?.data?.message || 'Failed to create enterprise');
    }
  };


  export const _getTypeFreelance = async (path = '/retrieve-global-domains')=>{
    try {
      const response:any = await get(path);
      return response.data.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to get data');
    }
  }